module.exports = __webpack_public_path__ + "static/media/microsoft-2-scan.4662afb3.png";